var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>TG0</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>TG1</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>TG2</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>TG3</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>TG4</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>TG5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>TG6</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="TG 0" data-betCode="440" class="bet-choose" data-odd="'+quotes.TotalGoal0+'">'+globalFunctions.checkQuotes(quotes.TotalGoal0)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="TG 1" data-betCode="441" class="bet-choose" data-odd="'+quotes.TotalGoal1+'">'+globalFunctions.checkQuotes(quotes.TotalGoal1)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="TG 2" data-betCode="442" class="bet-choose" data-odd="'+quotes.TotalGoal2+'">'+globalFunctions.checkQuotes(quotes.TotalGoal2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="TG 3" data-betCode="443" class="bet-choose" data-odd="'+quotes.TotalGoal3+'">'+globalFunctions.checkQuotes(quotes.TotalGoal3)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="TG 4" data-betCode="444" class="bet-choose" data-odd="'+quotes.TotalGoal4+'">'+globalFunctions.checkQuotes(quotes.TotalGoal4)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="TG 5" data-betCode="445" class="bet-choose" data-odd="'+quotes.TotalGoal5+'">'+globalFunctions.checkQuotes(quotes.TotalGoal5)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="TG 6" data-betCode="446" class="bet-choose" data-odd="'+quotes.TotalGoal6+'">'+globalFunctions.checkQuotes(quotes.TotalGoal6)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/total_goals.js
// module id = 2007
// module chunks = 4